import { getAction, listAction, createAction, deleteAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";


/**
 * Gets a center entry.
 */
export const getAssetEntry = function(value, slugOrId) {
	return getAction("media", value, slugOrId).then(data => {
		if (data.data[0])
			return processEntry(data.data[0]);
		if (data.data)
			return processEntry(data.data);
	});
}

/**
 * Gets a list of centers.
 */
export const getAssetsList = function() {
	return listAction("media").then(data => {
		return processList(data.data);
	});
}

/**
 * Create Asset entry.
 */
export const createAssetEntry = function(formData) {
	console.log("FormData: ", formData)
	return createAction("media", formData).then(data => {
		return data;
	});
}

/**
 * Deletes a Project.
 */
export const deleteAssetEntry = function (id) {
	return deleteAction("media", id, true).then(data => {
		return data;
	});
}

/**
 * Process data.
 */
const processData = function(data) {
	let content = data.data;
	return content;
}

/**
 * Process Entry.
 */
const processEntry = function(data) {
	let content = data;
	return content;
}

/**
 * Process List.
 */
const processList = function(data) {
	let content = data;

	content.map(value => {
		processEntry(value)
	})

	return content;
}



// WEBPACK FOOTER //
// ./src/data/models/asset.model.js